export default "__VITE_ASSET__DGGaAMyF__"